import { mainApi } from "services/main";
import { GetTaskByIdResponse, GetTaskByIdRequest } from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaskById: builder.query<GetTaskByIdResponse, GetTaskByIdRequest>({
      query: (request: GetTaskByIdRequest) => ({
        url: "tasks/" + request.taskId,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetTaskByIdQuery } = extendedApi;
